import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";

async function getCampaignCompletion(
  workspaceId: string,
  campaignId: string,
): Promise<number> {
  return (
    await get(`workspaces/${workspaceId}/campaigns/${campaignId}/completion`)
  ).completion;
}

export default function useCampaignCompletion(campaignId: string) {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { campaignsKeys } = getQueryKeys(workspaceId);

  const { data: completion, isLoading: isLoadingCompletion } = useQuery({
    queryKey: campaignsKeys.completion(campaignId),
    queryFn: () => getCampaignCompletion(workspaceId, campaignId),
  });

  return { completion, isLoadingCompletion };
}
